export interface TeamMember {
  id: number;
  name: string;
  nameEn: string;
  role: string;
  avatar: string;
  desc: string;
  specialty: string[];
  experience: string;
  education: string;
  projects: string;
}

export const teamMembers: TeamMember[] = [
  {
    id: 1,
    name: "莊詔傑",
    nameEn: "Zhuang Zhao-jie",
    role: "創辦人 / 台大土木工程碩士",
    avatar: "https://readdy.ai/api/search-image?query=Professional portrait of a confident Asian male architect in his 40s, wearing dark smart casual attire, warm studio lighting, clean neutral background, editorial headshot style, premium quality, soft cream and charcoal tones, architectural professional aesthetic, warm and approachable expression, modern and sophisticated style with minimalist background",
    desc: "深耕營造與設計多年，整合土木工程、建築設計與室內美學，協助業主掌握自地自建的效率、品質與風險控管。",
    specialty: ["土木結構", "專案管理", "營造整合", "風險評估"],
    experience: "15 年營造與設計經驗",
    education: "台灣大學土木工程碩士",
    projects: "主導超過 50 件自地自建與危老重建專案",
  },
  {
    id: 2,
    name: "蔡富廷",
    nameEn: "Martin",
    role: "設計經理 / 英國設計碩士",
    avatar: "https://readdy.ai/api/search-image?query=Professional portrait of a sophisticated Asian male designer in his mid-30s, wearing modern minimalist dark blazer, creative studio lighting, clean neutral background, editorial headshot style, premium quality, soft cream and charcoal tones, design professional aesthetic, confident and creative expression, modern architectural background elements",
    desc: "結合國際留學視野與實戰經驗，負責將建築外觀概念與室內空間機能整合轉化。",
    specialty: ["建築設計", "室內規劃", "外觀概念", "風格整合"],
    experience: "10 年建築與室內設計經驗",
    education: "英國設計碩士",
    projects: "主導唐誠設計與陳柏青建築師事務所合作專案",
  },
  {
    id: 3,
    name: "Olivia Hung",
    nameEn: "",
    role: "美學顧問 / 軟裝美學專家",
    avatar: "https://readdy.ai/api/search-image?query=Professional portrait of an elegant Asian female interior design consultant in her early 30s, wearing sophisticated neutral toned attire, soft natural lighting, clean minimal background, editorial headshot style, premium quality, warm cream and soft charcoal tones, artistic and refined aesthetic, warm creative expression, elegant and modern style",
    desc: "擁有多年藝術與室內美學背景，致力於為住宅空間注入精緻、溫潤的生活風格。",
    specialty: ["軟裝配置", "色彩規劃", "材質搭配", "燈光設計"],
    experience: "8 年室內美學與軟裝顧問經驗",
    education: "藝術與室內設計專業",
    projects: "為 40+ 住宅專案完成軟裝美學整合",
  },
  {
    id: 4,
    name: "林建全",
    nameEn: "",
    role: "土木 / 結構技師",
    avatar: "https://readdy.ai/api/search-image?query=Professional portrait of a experienced Asian male structural engineer in his late 40s, wearing professional dark shirt, confident warm lighting, clean neutral studio background, editorial headshot style, premium quality, soft cream and charcoal tones, engineering professional aesthetic, trustworthy and experienced expression, modern technical background elements",
    desc: "以專業結構技師背景，協助審核建築結構與安全，守護住宅品質。",
    specialty: ["結構計算", "耐震設計", "結構審核", "安全評估"],
    experience: "20 年結構工程與技師執業經驗",
    education: "土木工程學士 / 結構技師執照",
    projects: "審核超過 200 件建築結構設計案",
  },
  {
    id: 5,
    name: "唐宏偉",
    nameEn: "Henry Tang",
    role: "建築師 / 唐誠設計主持",
    avatar: "https://readdy.ai/api/search-image?query=Professional portrait of a distinguished Asian male architect in his mid-40s wearing modern dark-rimmed glasses and a charcoal wool blazer over a white shirt, standing in a bright minimalist studio with architectural blueprints subtly visible in the soft-focus background, warm directional lighting from the left creating gentle shadows, editorial headshot quality, sophisticated cream and graphite color palette, confident intellectual expression, clean modern professional aesthetic, no text no logos",
    desc: "專精於現代鋼構住宅與預製建築設計，擅長將業主的生活想像轉化為可執行的建築藍圖。",
    specialty: ["鋼構建築", "預製建築", "綠建築設計", "立面設計"],
    experience: "18 年建築師執業經驗",
    education: "成功大學建築學士 / 建築師執照",
    projects: "設計超過 60 件現代住宅與商業建築",
  },
  {
    id: 6,
    name: "張瑞煦",
    nameEn: "Ray Chang",
    role: "預製工法總監 / 瑞煦建築",
    avatar: "https://readdy.ai/api/search-image?query=Professional portrait of a capable Asian male construction manager in his late 30s wearing a navy polo shirt with a subtle company logo area, standing confidently with arms crossed in a modern prefabricated steel construction factory environment with steel beams and industrial equipment in soft-focus background, warm industrial lighting with slight orange tungsten tones, editorial headshot quality, premium professional aesthetic, cream and charcoal color palette with warm steel accents, determined and experienced expression, clean modern industrial atmosphere, no text no logos",
    desc: "預製工法領域專家，負責工廠預製流程管理與現場組裝品質控管，確保每一個構件精準到位。",
    specialty: ["預製工法", "工廠管理", "品質控管", "施工排程"],
    experience: "12 年預製建築與營造管理經驗",
    education: "台北科技大學營建工程學士",
    projects: "主導 30+ 預製鋼構住宅專案之工法落實",
  },
];

export const services = [
  {
    id: 1,
    icon: "ri-pencil-ruler-2-line",
    titleKey: "about.services.card1.title",
    subtitleKey: "about.services.card1.subtitle",
    descKey: "about.services.card1.desc",
  },
  {
    id: 2,
    icon: "ri-hammer-line",
    titleKey: "about.services.card2.title",
    subtitleKey: "about.services.card2.subtitle",
    descKey: "about.services.card2.desc",
  },
  {
    id: 3,
    icon: "ri-building-4-line",
    titleKey: "about.services.card3.title",
    subtitleKey: "about.services.card3.subtitle",
    descKey: "about.services.card3.desc",
  },
  {
    id: 4,
    icon: "ri-home-smile-line",
    titleKey: "about.services.card4.title",
    subtitleKey: "about.services.card4.subtitle",
    descKey: "about.services.card4.desc",
  },
  {
    id: 5,
    icon: "ri-paint-brush-line",
    titleKey: "about.services.card5.title",
    subtitleKey: "about.services.card5.subtitle",
    descKey: "about.services.card5.desc",
  },
];